import { T } from "../../../../../_ovlclient/src/global/globals"
//@ts-ignore
import logo from "../../img/favicon-196x196.png"
import { SYSBaseElement } from "../../../../../_ovlclient/src/library/sysbaseelement"
import { html, unsafeHTML } from "../../../../../_ovlclient/src"
export class NewServiceFormHeader extends SYSBaseElement {
  async getUI() {
    return html` <div class="fd-layout-panel__header">
      <div class="fd-layout-panel__head">
        <div class="fd-layout-panel__title svltitle">
          ${unsafeHTML(T("NewServiceTitle"))}
        </div>
        <p class="fd-layout-panel__description svltitlehint">
          ${unsafeHTML(T("NewServiceTitleHint"))}
        </p>
      </div>
      <div class="fd-layout-panel__actions">
        <a href="${T("NewServiceLinkProcessFinishedRedirect")}" target="_blank">
          <img class="headerimg" alt="logo" src="${logo}" />
        </a>
      </div>
    </div>`
  }
}
